import { Navigate } from "react-router-dom";
import { usePermission } from "../hooks/usePermission";
import Loader from "@/components/Loader/Loader";
import { ROUTES } from "../constants";
import { PrivateRouteProps } from "../type/type";

const PrivateRoute = ({
  module,
  permission,
  children,
}: PrivateRouteProps): React.ReactNode => {
  const { can, isLoaded } = usePermission();

  if (!isLoaded) {
    return <Loader />;
  }

  if (!can(module, permission)) {
    return <Navigate to={ROUTES.notFound} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
